import SettingsPage from './settingsPage';

export default SettingsPage;
